const styles = theme => {
  return ({
    root: {
      width: '600px',
      maxWidth: '90vw',
    },
    buttons: {
      display: 'flex',
      gap: '8px',
      alignSelf: 'end',
      marginTop: '16px',
    },
    tableContainer: {
      height: '300px',
      overflow: 'auto',
      border: '0.5px solid var(--border-color)',
      borderRadius: 'var(--radius)'
    },
    table: {
      width: '100%',
      border: 0,
    },
    tableHeader: {
      position: 'sticky',
      top: 0,
      background: 'var(--overlay-background)',
      zIndex: 1
    },
  })
}

export default styles
